export default class FkContactForm{

    /**
     * Envoie le formulaire (via "cq-on-sumit=sendFomr(this)" ).
     */
    static sendForm(){
        let $form, $fields, data, $message;
        $form=this;
        $message=$form.find(".js-message");

        //console.log("----send form 1-----",$form);
        $fields=$form.find("[name]");
        data={};
        $fields.each(function () {
            data[$(this).attr("name")]=$(this).val();
        });
        //console.log("----send form 2-----",data);
        $message.text("Veuillez patienter");
        window.pov.api.action("formContact",data).then(
            function(r){
                //console.log("----send form 3 (success)-----",r);
                $message.text("Votre message a été envoyé, nous vous répondrons dès que possible.");
            }
        ).catch(
            function(r){
                //console.log("----send form 4 (err)-----",r);
                $message.text("Il y a eu une erreur quand le formulaire a été envoyé");
            }
        );




    }

}


// WEBPACK FOOTER //
// ./fk.app/_src/forms/FkContactForm.js